import { useTranslation } from "@coworker/locales";
import { NotificationTranslationKeyType } from "../types/task-notification.types";

export function useNotificationString(
  notificationString: string | NotificationTranslationKeyType
): string {
  const { t } = useTranslation();
  if (typeof notificationString === "string") return notificationString;
  const { key, options } = notificationString;
  return t(key, options);
}
